import React, { useEffect } from 'react';
import { Layout, Breadcrumb, Empty } from 'antd';
import * as S from './Lots.styled';
import { IsAcceptedSelector, IsOwnerSelector, IsManagerSelector } from 'features/User/UserSlice';
import Meta from 'components/Meta';
import { useAppDispatch } from 'hooks/useStore';
import { useSelector } from 'react-redux';
import { fetchLots } from 'features/LotsList/LotsListSlice';
import LotsList from 'features/LotsList';
import { fetchComplexes } from 'features/ComplexesList/ComplexesListSlice';
import { fetchOrganizations } from 'features/OrganizationsList/OrganizationsListSlice';

const { Content } = Layout;

const Lots = (): JSX.Element => {
	const dispatch = useAppDispatch();

	// Подтвержденность пользователя
	const isAccepted = useSelector(IsAcceptedSelector);
	const isManager = useSelector(IsManagerSelector);
	const isOwner = useSelector(IsOwnerSelector);

	useEffect(() => {
		if (isOwner || (isAccepted && isManager)) dispatch(fetchOrganizations());
		if (isOwner || (isAccepted && isManager)) dispatch(fetchLots());
		if (isOwner || (isAccepted && isManager)) dispatch(fetchComplexes());
	}, [dispatch, isAccepted, isManager, isOwner]);

	return (
		<>
			<Meta pageName="requests" />
			<Content
				style={{
					padding: '0px 20px 20px 20px',
					display: 'flex',
					flexDirection: 'column',
				}}>
				<Breadcrumb
					items={[{ title: 'realty platform' }, { title: 'lots' }]}
					style={{ margin: '16px 0' }}
				/>
				<S.WorkSpace>
					{isOwner || (isAccepted && isManager) ? (
						<LotsList />
					) : (
						<S.Empty>
							<Empty
								image={Empty.PRESENTED_IMAGE_SIMPLE}
								description="You do not have the necessary rights to view this section"
							/>
						</S.Empty>
					)}
				</S.WorkSpace>
			</Content>
		</>
	);
};

export default Lots;
